import { createUseStyles } from 'react-jss';
import { getFocusBoxShadow } from '../../Forms/focus';
import { disabledButtonOpacity } from '../../Forms/Button/useButtonClasses';
export const useIconClasses = createUseStyles({
    icon(props) {
        const rules = props.isButtonIcon
            ? {
                cursor: props.isDisabled ? 'default' : 'pointer',
                outline: 'none',
                textDecoration: 'none',
                '&:focus-visible': {
                    boxShadow: getFocusBoxShadow(props.theme),
                },
                opacity: props.isDisabled ? disabledButtonOpacity : undefined,
                pointerEvents: props.isDisabled ? 'none' : undefined,
                background: 'transparent',
            }
            : {};
        return rules;
    },
});
